import * as yup from 'yup'

export const schemaStepCompany = yup.object().shape({
  name: yup.string(),
  tradeName: yup.string(),
  companyName: yup.string().required(),
  email: yup
    .string()
    .email()
    .emailAvailable()
    .required(),
  cpf: yup.string().cpf(),
  cnpj: yup
    .string()
    .cnpj()
    .cnpjAvailable()
    .required(),
  phone: yup.string().required(),
})

export default schemaStepCompany
